import { create } from 'zustand';

/** Opens the deposit and withdrawal dialog from any menu. */
export const usePaymentsDialog = create<{ open: boolean; show: () => void; hide: () => void }>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
